import styled from 'styled-components';

const ManageText = styled.h4`
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 300;
`;

export default ManageText;
